// createAction and handleActions with redux-actions 2's behaviour, for the
// forms the services use. Replaces the redux-actions package: 3.x is ESM-only
// and reads import.meta, which Jest's CommonJS transform can't load.
//
// createAction(type, payloadCreator?) returns (...args) => { type, payload?, error? }.
// The payload is payloadCreator(...args), or the first argument without one.
// An Error as the first argument becomes the payload as is, with error: true.
export function createAction(type, payloadCreator) {
  const actionCreator = (...args) => {
    const payload = !payloadCreator || args[0] instanceof Error ? args[0] : payloadCreator(...args);
    const action = { type };
    if (payload instanceof Error) action.error = true;
    if (payload !== undefined) action.payload = payload;
    return action;
  };
  actionCreator.toString = () => String(type);
  return actionCreator;
}

// handleActions({ [type]: (state, action) => newState }, defaultState) returns
// a reducer that runs the handler for action.type and leaves other actions alone.
export function handleActions(handlers, defaultState) {
  if (defaultState === undefined) {
    throw new Error(`defaultState for reducer handling ${Object.keys(handlers).join(', ')} should be defined`);
  }
  return (state = defaultState, action) => {
    const type = action && action.type;
    if (!type || !Object.prototype.hasOwnProperty.call(handlers, type)) return state;
    return handlers[type](state, action);
  };
}
